module.exports = __webpack_public_path__ + "img/UY.9af017be.png";